<template>
  <Tabs>
    <!-- <TabPane label="58生意转让">
      <list1 />
    </TabPane> -->
    <TabPane label="58生意转让新版">
      <list2 />
    </TabPane>
  </Tabs>
</template>
<script>
// import list1 from "./list1";
import list2 from './list2';

export default {
  name: 'data1',
  components: { list2 },
  data () {
    return {};
  }
};
</script>
